"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getTranslations;

var _de = _interopRequireDefault(require("../../translations/de.json"));

var _en = _interopRequireDefault(require("../../translations/en.json"));

var _es = _interopRequireDefault(require("../../translations/es.json"));

var _fr = _interopRequireDefault(require("../../translations/fr.json"));

var _it = _interopRequireDefault(require("../../translations/it.json"));

var _ko = _interopRequireDefault(require("../../translations/ko.json"));

var _pt = _interopRequireDefault(require("../../translations/pt.json"));

var _tr = _interopRequireDefault(require("../../translations/tr.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * NOTE: This is not 100% DRY. Consider changing the supported locales as well
 */
function getTranslations() {
  return {
    de: _de.default,
    en: _en.default,
    es: _es.default,
    fr: _fr.default,
    it: _it.default,
    ko: _ko.default,
    pt: _pt.default,
    tr: _tr.default
  };
}